import Button from '@viking-eng/button';
import InputText from '@viking-eng/input-text';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Field, Form, reset } from 'redux-form';

import './SearchByUser.scss';
import { ERROR_CODES, ERROR_MESSAGES, required, validEmail } from 'common/forms/Validations';
import UserInfo from 'components/UserInfo/UserInfoContainer';

const SearchByUser = ({ b2cUpdateStatus, clearEmailFormData, handleSubmit, submitting }) => {
  useEffect(() => {
    clearEmailFormData();
    reset('userManagement');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const LABELS = {
    BUTTON_SEARCH: 'SEARCH',
    DESCRIPTION:
      'User Management allows the Production Support team to lookup users by their email address and modify the user type and first and last name. Changes will only update to MS Azure B2C active directory (not to Evo or Dynamo).',
    INPUT_EMAIL: 'B2C Login Email',
    TITLE: 'Search User Email',
  };

  return (
    <>
      <div className="search-form-container">
        <Form className="search-form pt-3" name="userManagement" onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-12">{LABELS.DESCRIPTION}</div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="h5 mt-4 pb-3">{LABELS.TITLE}</div>
              <div className="row">
                <div className="search-form-input-wrapper col-5">
                  <Field
                    component={InputText}
                    errorCodes={{
                      [ERROR_CODES.INVALID_EMAIL_FORMAT]: ERROR_CODES.INVALID_EMAIL_FORMAT,
                      [ERROR_CODES.REQUIRED]: ERROR_CODES.EMAIL_REQUIRED,
                    }}
                    errorMessages={ERROR_MESSAGES}
                    id="userEmail"
                    name="userEmail"
                    normalize={(value) => value.trim()}
                    placeholder={LABELS.INPUT_EMAIL}
                    validate={[required, validEmail]}
                    onChange={clearEmailFormData}
                  />
                </div>
                <div className="col-2">
                  <Button appearance="secondary-blue" attributes={{ type: 'submit' }} loading={submitting}>
                    {LABELS.BUTTON_SEARCH}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Form>
        {b2cUpdateStatus?.message ? (
          <>
            <div className="row mt-5">
              <div className="col-12 status-message text-center m-auto">{b2cUpdateStatus.message}</div>
            </div>
          </>
        ) : (
          <UserInfo />
        )}
      </div>
    </>
  );
};

SearchByUser.propTypes = {
  b2cUpdateStatus: PropTypes.shape({ message: PropTypes.string }),
  booking: PropTypes.shape({
    data: PropTypes.shape({
      passengers: PropTypes.arrayOf(PropTypes.shape({})),
      bookingId: PropTypes.string,
      cruiseID: PropTypes.string,
      cruiseName: PropTypes.string,
    }),
  }),
  clearEmailFormData: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

SearchByUser.defaultProps = {
  b2cUpdateStatus: {
    message: '',
  },
  booking: {},
};

export default SearchByUser;
